<ng-container *adaptLoadingUntilFirstEmit="let team of team$">
    <adapt-display-systems class="d-block mb-3 h-100"
                           [fullPageCTA]="true"
                           [team]="team"></adapt-display-systems>
</ng-container>
